export enum WebsocketChannels {
  VoicesLobby = 'circles_voices_lobby'
}
